import { ErrorCode } from '../custom/error-code'
import { SESSION_ERROR } from '../custom/session-error'

export class DBCOLLECTOR_SESSION_ERROR extends SESSION_ERROR {

    // Properties

    public errorCode: ErrorCode;

    // Properties End


    // Ctor

    constructor(opObject: any = null) {
        super(opObject)
    }

    // Ctor End


    // SESSION_ERROR Overrides

    public fromJSON(opObj: any, compressed: boolean = false): void {
        super.fromJSON(opObj, compressed)

        if (opObj) {
            this.errorCode = opObj.ErrorCode != null ? new ErrorCode(opObj.ErrorCode) : null
        }
    }

    public toJSON(compressed: boolean = false): any {
        const result: any = super.toJSON(compressed)

        if (result != null) {
            result.ErrorCode = this.errorCode != null ? this.errorCode.toJSON(compressed) : null 
        }

        return result
    }

    // SESSION_ERROR Overrides End
}
